const smooth = (from, to, value) => {
  const t = Math.max(0, Math.min(1, (value - from) / (to - from)));
  return t * t * (3 - 2 * t);
};

// Follow the saved game clock, not the computer clock or storm brightness.
export function wildlifeActivityAt(hour) {
  const h = ((Number.isFinite(hour) ? hour : 12) % 24 + 24) % 24;
  return {
    birdFlight: smooth(6, 7, h) * (1 - smooth(17, 18, h)),
    fishSpeed: .3 + .7 * smooth(5.5, 7, h) * (1 - smooth(17, 19, h)),
  };
}

export function seagullPose(bird, flightTime, flight) {
  const angle = bird.phase + flightTime * bird.speed;
  const blend = (rest, flying) => rest + (flying - rest) * flight;
  const flyingHeading = Math.atan2(Math.cos(angle), -Math.sin(angle)) + (bird.speed < 0 ? Math.PI : 0);
  const turn = Math.atan2(Math.sin(flyingHeading - bird.rest.heading), Math.cos(flyingHeading - bird.rest.heading));
  return {
    x: blend(bird.rest.x, Math.cos(angle) * bird.radius),
    y: blend(bird.rest.y, bird.y + Math.sin(flightTime * 1.4 + bird.bob) * bird.bobble),
    z: blend(bird.rest.z, Math.sin(angle) * bird.radius),
    heading: bird.rest.heading + turn * flight,
    bank: flight ? bird.bank * Math.sin(flightTime * 1.7 + bird.bob) * flight : 0,
  };
}
